import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getRoutesProp } from 'lib/utils/routing';
import shopControlsVisibilities from 'lib/apps/header/utils/shopControlsVisibilities';

import AppBanner from 'lib/apps/appBanner/containers/AppBanner';
import HeaderSearch from 'lib/apps/header/containers/HeaderSearch';
import NavigationMenu from 'lib/apps/topNavigation/containers/NavigationMenu';
import TrolleyMenu from 'lib/apps/trolleyMenu/containers/TrolleyMenu';

import JavascriptDisabledAlert from 'lib/apps/browserWarnings/containers/JavascriptDisabledAlert';
import OfflineAlert from 'lib/apps/browserWarnings/containers/OfflineAlert';
import PostcodeBanner from 'lib/apps/header/containers/PostcodeBanner';
import UnsupportedBrowserAlert from 'lib/apps/browserWarnings/containers/UnsupportedBrowserAlert';

import Basket from '../containers/Basket';
import PrimaryBar from '[theme-lib]/apps/ospHeader/containers/PrimaryBar';
import CheckoutButton from '../containers/CheckoutButton';

import BrandLogo from '../containers/BrandLogo';
import TopNavigation from './TopNavigation';
import HeaderButtons from './HeaderButtons';
import MobileMenu from './MobileMenu';

const Header = (props) => {
  const {
    closeMobileNav,
    isLoggedIn,
    isBasketDropdownEnabled,
    location,
    mobileNavOpened,
    openMobileNav,
    reportTopTabClicked,
    routes,
  } = props;

  const basketVisible = getRoutesProp(routes, 'basketVisible');
  const shopControlsVisibility = getRoutesProp(routes, 'shopControlsVisibility', shopControlsVisibilities.NONE);

  return (
    <>
      <header className="hd-header hd-header-alternative stickToTop rs-stickyHeader">
        <JavascriptDisabledAlert />
        <UnsupportedBrowserAlert />
        <OfflineAlert />
        <AppBanner location={location} />
        <div className="hd-header__tabsAndHeader">
          <TopNavigation isLoggedIn={isLoggedIn} reportTopTabClicked={reportTopTabClicked} />
          <MobileMenu
            closeMenu={closeMobileNav}
            isMenuOpened={mobileNavOpened}
            openMenu={openMobileNav}
            pathname={location.pathname}
          />
          <div className="hd-header__header">
            <BrandLogo />
            <div className="hd-header__controls">
              <div className="hd-header__search">
                <HeaderSearch
                  multiSearchText="Use a list"
                  multiSearchLinkText="Find a list of products"
                  showSimpleMultiSearch
                />
              </div>
              <div className={classNames('hd-header__buttons', { 'hd-header__buttons--loggedOut': !isLoggedIn })}>
                <HeaderButtons
                  isLoggedIn={isLoggedIn}
                  shopControlsVisibility={shopControlsVisibility}
                />
                <Basket
                  isBasketDropdownEnabled={isBasketDropdownEnabled}
                  isBasketVisible={basketVisible}
                />
                <CheckoutButton shopControlsVisibility={shopControlsVisibility} />
              </div>
            </div>
          </div>
          <PrimaryBar />
        </div>
      </header>
      <NavigationMenu location={location} />
      <TrolleyMenu shopControlsVisibility={shopControlsVisibility} />
      <PostcodeBanner />
    </>
  );
};

Header.propTypes = {
  betaFeatures: PropTypes.array.isRequired,
  closeMobileNav: PropTypes.func.isRequired,
  isDesktopBreakpoint: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  location: PropTypes.object,
  mobileNavOpened: PropTypes.bool,
  openMobileNav: PropTypes.func.isRequired,
  reportTopTabClicked: PropTypes.func,
  routes: PropTypes.array,
};

export default Header;
